<template>
  <div class="container">
    <p class="label" v-safe-html="label" />
    <p class="description" v-if="description" v-safe-html="description" />
    <p class="detail" v-safe-html="detail" />
    <p class="linktitle" v-if="linktitle" v-safe-html="linktitle" />
  </div>
</template>

<script>
export default {
  name: "OfferElement",
  props: {
    label: String,
    description: String,
    detail: String,
    labelLight: [Boolean, String],
    link: String,
    cbu: String,
    modal: String,
    linktitle: String,
    linkpath: String,
    buttonLabel: String,
    buttonLink: String
  }
};
</script>
